import { Formik, FormikHelpers } from 'formik'
import { Button, Modal } from '../../../../components'
import { ModalProps } from '../../../holidays/components/types'
import SelectField from '../../../../components/Form/Select'
import { useNavigate } from 'react-router-dom'

interface LocFormValues {
    location: string
}
const SetLocation = ({ show, onClose }: ModalProps) => {
    const navigate = useNavigate()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Select Location"
            body={
                <Formik
                    initialValues={{
                        location: '',
                    }}
                    onSubmit={async (
                        values,
                        actions: FormikHelpers<LocFormValues>
                    ) => {
                        actions.setSubmitting(false)
                        onClose(false)
                        navigate('/users/sync')
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <SelectField
                                name="exampleSelect"
                                label="Select Location"
                                options={[
                                    {
                                        value: '',
                                        label: '',
                                    },
                                    {
                                        value: 'Australia',
                                        label: 'Australia',
                                    },
                                ]}
                                value={values.location}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.location}
                                touched={touched.location}
                                defaultValue="option1"
                            />
                            <div className="footer-block">
                                <Button disabled={isSubmitting} type="submit">
                                    SELECT
                                </Button>
                                <Button
                                    disabled={isSubmitting}
                                    type="submit"
                                    variant="outline-success"
                                    onClick={() => onClose(false)}
                                >
                                    CANCEL
                                </Button>
                            </div>
                        </form>
                    )}
                </Formik>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default SetLocation
